import { memo } from 'react';
import { Box, Grow, InputAdornment, TextField } from '@mui/material';
import { classNames } from '../../../utils';
import { ButtonUi } from '../Button/Button';
import { inputStyle } from './style';

export const InputUi = memo((props) => {
  const {
    label,
    className,
    value,
    variant = 'outlined',
    onInputChangeHandler,
    onInputFocusHandler,
    onInputBlurHandler,
    name,
    required,
    endButton = false,
    btnText,
    btnVariant,
    btnClassName,
    btnType = 'input',
    btnSize = 'small',
    btnDisabled,
    btnClickHandler,
    btnTooltip,
    AdditionalButton,
    hideBtn,
  } = props;
  const { input } = inputStyle;

  /**
   * Input on change handler
   */
  const onChangeHandler = (event) => {
    onInputChangeHandler(event.target.value);
  };


  return (
    <TextField
      sx={input}
      className={className}
      id='outlined-basic'
      name={name}
      required={required}
      label={label}
      variant={variant}
      value={value}
      onChange={onChangeHandler}
      onFocus={onInputFocusHandler}
      onBlur={onInputBlurHandler}
      InputProps={{
        endAdornment: endButton && (
          <InputAdornment position='end'>
            <Grow in={!hideBtn} {...(hideBtn ? { timeout: 0 } : {})}>
              <Box>
                <ButtonUi
                  disabled={btnDisabled}
                  className={classNames('input-btn', {}, [btnClassName])}
                  variant={btnVariant}
                  type={btnType}
                  size={btnSize}
                  onClickHandler={btnClickHandler}
                  tooltipTitle={btnTooltip}
                  tooltipPlacement='top'
                >
                  {btnText}
                </ButtonUi>
              </Box>
            </Grow>
            {AdditionalButton}
          </InputAdornment>
        ),
      }}
    />
  );
});
